// Used on legacy pages (Enterprise, About Us, etc)
// JS Base
import '../js/base/legacy';
import '../js/index';

// Base SCSS
import '../scss/base.scss';
import '../scss/components/card.scss';

import '../scss/basepage.scss';
import '../scss/components/nodes.scss';
import '../scss/webinars.scss';

$(() => {
  $('#show-all').on('click', () => {
    $('.webinar-card').each((i, c) => {
      const card = $(c);
      card.show();
      $('#filter-display').hide();
    });
  });

  $('.tags span').on('click', ({ target }) => {
    // Get the text of the clicked tag
    const selectedTag = $(target).text().trim();

    // Loop through each webinar-card element
    $('.webinar-card').each((i, c) => {
      const card = $(c);
      const cardTags = card.find('.tags span').toArray().map((t) => $(t).text().trim());

      // Check if the selected tag exists in the current card's tags
      if (cardTags.includes(selectedTag)) {
        card.show();  // Show card if it has the selected tag
      } else {
        card.hide();  // Hide card if it doesn't have the selected tag
      }
    });

    $('html, body').animate({ scrollTop: 0 }, 'slow', () => {});
    $('#filter-display').show();
    $('#filter-display h3').text(`Showing only: ${selectedTag}`);
  });
});
